export const deepCopyObject = <T>(obj: T) => {
    return JSON.parse(JSON.stringify(obj));
};
